import React from "react";
import { hot } from 'react-hot-loader';

import INTERFACE from "../setting/interface_docx";
import GroupItem from './GroupItem';
import styles from './SettingInterfaceDocx.module.css';

const copyObject = (data) => {
  return Object.assign({}, JSON.parse(JSON.stringify(data)));
}

const SettingInterfaceDocx = ({ setting, setSetting, optional }) => {
  const contents = setting.contents
  const rows = []

  INTERFACE.forEach((item) => {
    let val = false;
    
    if (item.path in contents) {
      val = contents[item.path]
    }
    rows.push(
      <tr key={item.path}>
        <td><GroupItem text={item.group} /></td>
        <td>{item.title}</td>
        <td><input type="checkbox" checked={val} onChange={(e) => {
          let newSetting = copyObject(setting)
          newSetting.contents[item.path] = e.target.checked
          setSetting(newSetting)
        }} /> 出力する</td>
      </tr>
    );
  })

  return (
    <div className={styles.interface}>
      <table style={{maxHeight: "400px", overflowY: "auto", display: "block"}}>
        <thead>
          <tr>
            <th style={{width: "28%"}}>分野</th>
            <th style={{width: "42%"}}>コンテンツ</th>
            <th style={{width: "12%"}}>選択</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  )
}

export default hot(module)(SettingInterfaceDocx);
